/**
 * 凡例一覧。
 * 各凡例グループをcode, name, listを持つオブジェクトとして実際の表示順に配列形式で記載する。
 * path, code はいずれか1つのみを持つ。
 * path: ツリー上の表示位置、文字列か正規表現で指定。ディレクトリー名の間は'/'で区切る。
 * code: 情報種別コード。表示中のレイヤーに当該種別のものがあれば、その凡例グループを表示する。
 * name: 凡例グループ名。path指定時は省略可能。pathが正規表現の場合、マッチ結果をnameとして用いる。
 *       その場合、マッチ結果にグループ指定がある場合は先頭グループ、無ければマッチ結果全体を用いる。
 *       例： /市（避難経路）$/ → '避難経路', /避難経路$/ → '避難経路',
 * list: 凡例グループに紐付く凡例の一覧
 *
 * 各凡例は以下の属性を持つ。
 * src, line, area は表示形式によりいずれか1つのみを持つ。
 * name: 凡例名
 * src: アイコンのURL（画像の場合）
 * line: 表示色（線の場合）
 * area: 表示色（領域の場合）
 *
 * @module app/map/legend/LEGEND_LIST
 */
define([{
    path: /^事前情報\/浸水想定区域/,
    list: [
        { name: '0.3m未満', area: '#ffffb3' },
        { name: '0.3m以上～0.5ｍ未満', area: '#f7f5a9' },
        { name: '0.5m以上～1ｍ未満', area: '#f8e1a6' },
        { name: '1m以上～3ｍ未満', area: '#ffd8c0' },
        { name: '3m以上～5ｍ未満', area: '#ffb7b7' },
        { name: '5m以上～10ｍ未満', area: '#ff9191' },
        { name: '10m以上～20ｍ未満', area: '#f285c9' },
        { name: '20ｍ以上', area: '#dc7adc' },
        { image: 'images/flooding/description.png' }
    ]
}, {
    path: /^事前情報\/土砂災害警戒区域/,
    list: [
        { name: '土石流 警戒区域', area: '#FFFD54', line: '#F8D38B' },
        { name: '土石流 特別警戒区域', area: '#F59891', line: '#F8B7B2' },
        { name: '急傾斜地 警戒区域', area: '#FFFD54', line: '#F8D38B' },
        { name: '急傾斜地 特別警戒区域', area: '#F59891', line: '#F8B7B2' },
        { name: '地すべり 警戒区域', area: '#FFFD54', line: '#F8D38B' }
    ]
}, {
    path: /^事前情報\/砂防指定地等/,
    list: [
        { name: '砂防指定地', area: '#ACAFF3', line: '#FF0000' },
        { name: '地すべり防止区域(国交省所管)', area: '#E0EBF6', line: '#FF0000' },
        { name: '地すべり防止区域(農水省所管)', area: '#B48D2F', line: '#36538A' },
        { name: '地すべり防止区域(林野庁所管)', area: '#B2D9A2', line: '#383B38' },
        { name: '急傾斜地崩壊危険区域', area: '#A9A9A9', line: '#FF0000' }
    ]
}, {
    // 津波災害情報
    name: '津波災害警戒区域図',
    path: /^事前情報\/津波災害情報\/津波災害警戒区域図/,
    list: [
        { name: '津波災害警戒区域図', area: '#FEF9F3' },
        {
            name: '津波災害警戒区域図PDFはこちら',
            link: ''
        }
    ]
}, {
    // 津波災害情報
    name: '津波浸水想定図',
    path: /^事前情報\/津波災害情報\/津波浸水想定/,
    list: [
        { name: '0.5m未満', area: '#f7f5a9' },
        { name: '0.5m以上～3.0ｍ未満', area: '#ffd8c0' },
        { name: '3m以上～5ｍ未満', area: '#ffb7b7' },
        { name: '5m以上～10ｍ未満', area: '#ff9191' },
        { name: '10m以上～20ｍ未満', area: '#f285c9' },
        { name: '20ｍ以上', area: '#dc7adc' },
        { image: 'images/flooding/description.png' }
    ]
}, {
    // 保安林
    path: /^事前情報\/保安林/,
    list: [
        { name: '保安林指定地', area: '#2C70BA', line: '#000000' }
    ]
}, {
    // 山地災害危険地区(森林整備室所管)
    path: /^事前情報\/山地災害危険地区/,
    list: [
        { name: '山腹崩壊危険地区', area: '#F1CCE3', line: '#EB7DB5' },
        { name: '地すべり危険地区', area: '#F3D08A', line: '#E4B162' },
        { name: '崩壊土砂流出危険地区', area: '#CFCFCF', line: '#A0A0A0' }
    ]
}, {
    path: /^事前情報\/（公共施設）/,
    list: [
        { name: '道土整備事務所', src: '/images/facility/3303.gif' },
        { name: '病院', src: '/images/facility/3332.gif' },
        { name: '都道府県の機関', src: '/images/facility/3303.gif' },
        { name: '市役所・役場', src: '/images/facility/3387.gif' },
        { name: '市/行政区の機関', src: '/images/facility/3319.gif' },
        { name: '公企体及び独法東北', src: '/images/draw/icon/001.png' },
        { name: '消防署', src: '/images/facility/3316.gif' },
        { name: '警察署', src: '/images/facility/3314.gif' },
        { name: '小学校', src: '/images/facility/3354.gif' },
        { name: '中学校', src: '/images/facility/3355.gif' },
        { name: '高等学校', src: '/images/facility/3356.gif' },
        { name: '大学校', src: '/images/facility/3360.gif' },
        { name: '鉄道', area: '#0000FF' },
        { name: '駅', src: '/images/draw/icon/020.png' }
    ]
}, /* {
    path: /^事前情報\/（道路）/,
    list: [
        { name: '冬期閉鎖区間', line: '#32CD32'},
        { name: '事前通行規制区間', line: '#32CD32'},
        { name: '特殊通行規制区間', line: '#32CD32'},
        { name: '通行不能区間', line: '#000000'},
        { name: '異常気象時通行規制区間', line: '#32CD32'},
        { name: '緊急輸送路', line: '#FF8C00'},
        { name: '主要地方道', line: '#008000'},
        { name: '一般県道', line: '#008000'},
        { name: '直轄国道', line: '#008000'},
        { name: '補助国道', line: '#008000'},
        { name: '高速道路', line: '#008000'},
        { name: 'IC・JCT', src: '/images/draw/icon/085.png'},
        { name: '有料道路', line: '#008000'},
        { name: '広域農道', line: '#008000'},
        { name: '林道', line: '#008000'},
        { name: 'キロポスト', src: '/images/draw/icon/077.png'},
        { name: '道路情報板', src: '/images/draw/icon/104.png'}
    ]
}, */ {
    path: /^事前情報\/（浸水想定区域）\/（津波浸水想定区域|高潮浸水想定区域）/,
    name: '津波・高潮浸水想定区域',
    list: [
        { name: '浸水深 0.01ｍ以上~0.3m未満', area: '#69FD9B' },
        { name: '浸水深 0.3m以上～1.0ｍ未満', area: '#FFF969' },
        { name: '浸水深 1m以上～2ｍ未満', area: '#FEC082' },
        { name: '浸水深 2m以上～3ｍ未満', area: '#FEE7CE' },
        { name: '浸水深 3m以上～4ｍ未満', area: '#FECEE5' },
        { name: '浸水深 4m以上～5ｍ未満', area: '#FC83BD' },
        { name: '浸水深 5m以上～10ｍ未満', area: '#FB5551' },
        { name: '浸水深 10m以上～20ｍ未満', area: '#C651FB' }
    ]
}, {
    path: /^事前情報\/（浸水想定区域）\/（洪水浸水想定区域）/,
    name: '洪水浸水想定区域',
    list: [
        { name: '浸水深 0.5m未満', area: '#F0F78D' },
        { name: '浸水深 0.5m以上～3.0ｍ未満', area: '#FFD29C' },
        { name: '浸水深 3m以上～5ｍ未満', area: '#FCAB90' },
        { name: '浸水深 5m以上～10ｍ未満', area: '#F08460' },
        { name: '浸水深 10m以上～20ｍ未満', area: '#FF80DF' }
    ]
}, {
    // 避難場所
    name: '避難場所',
    code: 'M005',
    list: [
        { name: '避難所', src: '/images/facility/1107.png' }
    ]
}, {
    path: /^事前情報\/（行政界）/,
    list: [
        { name: '道境界', line: '#0000FF' },
        { name: '事務所境界', line: '#0000FF' },
        { name: '市/行政区境界', line: '#0000FF' }
    ]
}, {
    // 雨量観測情報
    name: '10分雨量',
    code: 'O001',
    list: [
        { name: '30mm以上', src: '/images/observatory/rainfall/rainfall_Lv6.png' },
        { name: '20mm以上', src: '/images/observatory/rainfall/rainfall_Lv5.png' },
        { name: '10mm以上', src: '/images/observatory/rainfall/rainfall_Lv4.png' },
        { name: '5mm以上', src: '/images/observatory/rainfall/rainfall_Lv3.png' },
        { name: '1mm以上', src: '/images/observatory/rainfall/rainfall_Lv1.png' },
        { name: '無降雨', src: '/images/observatory/rainfall/rainfall_noRain.png' },
        { name: '欠測、閉局等', src: '/images/observatory/rainfall/rainfall_missing.png' },
    ]
}, {
    // 雨量観測情報
    name: '60分雨量',
    code: 'O011',
    list: [
        { name: '80mm以上', src: '/images/observatory/rainfall/rainfall_Lv6.png' },
        { name: '50mm以上', src: '/images/observatory/rainfall/rainfall_Lv5.png' },
        { name: '30mm以上', src: '/images/observatory/rainfall/rainfall_Lv4.png' },
        { name: '20mm以上', src: '/images/observatory/rainfall/rainfall_Lv3.png' },
        { name: '10mm以上', src: '/images/observatory/rainfall/rainfall_Lv2.png' },
        { name: '1mm以上', src: '/images/observatory/rainfall/rainfall_Lv1.png' },
        { name: '無降雨', src: '/images/observatory/rainfall/rainfall_noRain.png' },
        { name: '欠測、閉局等', src: '/images/observatory/rainfall/rainfall_missing.png' },
    ]
}, {
    // 雨量観測情報
    name: '累加雨量',
    code: 'O012',
    list: [
        { name: '250mm以上', src: '/images/observatory/rainfall/rainfall_Lv6.png' },
        { name: '200mm以上', src: '/images/observatory/rainfall/rainfall_Lv5.png' },
        { name: '150mm以上', src: '/images/observatory/rainfall/rainfall_Lv4.png' },
        { name: '100mm以上', src: '/images/observatory/rainfall/rainfall_Lv3.png' },
        { name: '50mm以上', src: '/images/observatory/rainfall/rainfall_Lv2.png' },
        { name: '1mm以上', src: '/images/observatory/rainfall/rainfall_Lv1.png' },
        { name: '無降雨', src: '/images/observatory/rainfall/rainfall_noRain.png' },
        { name: '欠測、閉局等', src: '/images/observatory/rainfall/rainfall_missing.png' },
    ]
}, {
    // 水位観測情報
    name: '水位',
    code: 'O002',
    list: [
        { name: 'はん濫危険水位超過', src: '/images/observatory/riverlevel/riverlevel_danger_stay.png' },
        { name: '避難判断水位超過', src: '/images/observatory/riverlevel/riverlevel_evacuate_stay.png' },
        { name: 'はん濫注意水位超過', src: '/images/observatory/riverlevel/riverlevel_caution_stay.png' },
        { name: '水防団待機水位超過', src: '/images/observatory/riverlevel/riverlevel_standby_stay.png' },
        { name: '通常水位', src: '/images/observatory/riverlevel/riverlevel_standard_stay.png' },
        { name: '欠測、閉局等', src: '/images/observatory/riverlevel/riverlevel_missing_stay.png' },
        { name: '上昇中', src: '/images/observatory/riverlevel/up.png' },
        { name: '変化なし', src: '/images/observatory/riverlevel/stay.png' },
        { name: '下降中', src: '/images/observatory/riverlevel/down.png' }
    ]
}, {
    // 危機管理水位観測情報
    name: '危機管理型水位計',
    code: 'O018',
    list: [
        { name: 'はん濫開始水位超過', src: '/images/observation/crLv03.png' },
        { name: '危険水位超過', src: '/images/observation/crLv02.png' },
        { name: '観測開始水位超過', src: '/images/observation/crLv01.png' },
        { name: '通常水位', src: '/images/observation/crLv00.png' },
        { name: '欠測/閉局等', src: '/images/observation/crLvN.png' }
    ]
}, /* {
    // 潮位観測情報
    name: '潮位',
    code: 'O003',
    list: [
        { name: '警戒潮位以上', src: '/images/observation/choi03.png' },
        { name: '通報潮位以上', src: '/images/observation/choi04.png' },
        { name: '警戒潮位未満', src: '/images/observation/choi05.png' },
        { name: '欠測、閉局等', src: '/images/observation/choi06.png' }
    ]
}, {
    // 潮位観測情報
    name: 'ダム',
    code: 'O004',
    list: [
        { name: '洪水調節中', src: '/images/observation/dam_red.png' },
        { name: '洪水調節中以外（利水貯水率:50%以上）', src: '/images/observation/dam_green.png' },
        { name: '洪水調節中以外（利水貯水率:50%未満）', src: '/images/observation/dam_brown.png' },
        { name: '欠測、閉局等', src: '/images/observation/dam_white.png' }
    ]
}, */ {
    // 河川カメラ
    name: '河川カメラ',
    code: 'D200',
    list: [
        { name: 'カメラ', src: '/images/observation/river_camera.png' }
    ]
}, /* {
    // 道路通行規制
    name: '道路通行規制',
    code: 'D101',
    list: [
        { name: '全面通行止め（現在）', src: '/images/traffic/current_1.png' },
        { name: '車両通行止め（現在）', src: '/images/traffic/current_2.png' },
        { name: '片側交互通行（現在）', src: '/images/traffic/current_4.png' },
        { name: 'チェーン規制（現在）', src: '/images/traffic/current_6.png' },
        { name: 'その他（現在）', src: '/images/traffic/current_9.png' },
        { name: '全面通行止め（今後）', src: '/images/traffic/future_1.png' },
        { name: '車両通行止め（今後）', src: '/images/traffic/future_2.png' },
        { name: '片側交互通行（今後）', src: '/images/traffic/future_4.png' },
        { name: 'チェーン規制（今後）', src: '/images/traffic/future_6.png' },
        { name: 'その他（今後）', src: '/images/traffic/future_9.png' }
    ]
}, {
    // 長崎県道路通行規制情報
    name: '長崎県道路通行規制情報',
    code: 'R007',
    list: [
        { name: '全面通行禁止', src: '/images/draw/icon/traffic/mapinfo_tukodome.gif' },
        { name: '片側通行禁止', src: '/images/draw/icon/traffic/mapinfo_katagawakougo.gif' },
        { name: '大型車通行止め', src: '/images/draw/icon/traffic/mapinfo_oogatatukodome.gif' },
        { name: '車線・路肩規制', src: '/images/draw/icon/traffic/mapinfo_syasenkisei.gif' },
        { name: '歩道規制', src: '/images/draw/icon/traffic/mapinfo_hodoukisei.gif' }
    ]
}, */ {
    // 気象警報・注意報
    name: '気象警報・注意報',
    code: 'D102',
    list: [
        { name: '特別警報', area: '#0C000C' },
        { name: '危険警報', area: '#C800FF' },
        { name: '警報', area: '#FF2800' },
        { name: '注意報', area: '#F2E700' }
    ]
}, {
    // 高解像度降水ナウキャスト
    name: '高解像度降水ナウキャスト/ 降水短時間予報',
    code: 'O014',
    list: [
        { name: '～1mm/h', area: '#F2F2FF' },
        { name: '～5mm/h', area: '#A0D2FF' },
        { name: '～10mm/h', area: '#1C8CFF' },
        { name: '～20mm/h', area: '#0035FF' },
        { name: '～30mm/h', area: '#FFF500' },
        { name: '～50mm/h', area: '#FF9900' },
        { name: '～80mm/h', area: '#FF2000' },
        { name: '80mm/h～', area: '#B40068' }
    ]
}, {
    // 竜巻注意情報
    name: '竜巻注意情報',
    code: 'D106',
    list: [
        { name: '対象', area: '#F2E700' }
    ]
}, {
    // 大雨警報（浸水害）危険度分布
    name: '大雨警報（浸水害）危険度分布',
    code: 'O013',
    list: [
        { name: '【警戒レベル５相当】<br>災害切迫', area: '#0C000C' },
        { name: '危険', area: '#AA00AA' },
        { name: '警戒', area: '#FF2800' },
        { name: '注意', area: '#F2E700' }
    ]
}, {
    // 洪水警報危険度分布
    name: '洪水警報危険度分布',
    code: 'O015',
    list: [
        { name: '【警戒レベル５相当】<br>災害切迫', area: '#0C000C' },
        { name: '【警戒レベル４相当】<br>危険', area: '#AA00AA' },
        { name: '【警戒レベル３相当】<br>警戒', area: '#FF2800' },
        { name: '【警戒レベル２相当】<br>注意', area: '#F2E700' }
    ]
}, {
    // 大雨警報（土砂災害）危険度分布：スネークライン
    name: '大雨警報（土砂災害）危険度分布',
    code: 'D030',
    list: [
        { name: '災害切迫【警戒レベル5相当】', area: '#0C000C' },
        { name: '危険【警戒レベル４相当】', area: '#6c008c' },
        { name: '警戒【警戒レベル３相当】', area: '#FF2800' },
        { name: '注意【警戒レベル２相当】', area: '#FAF500' }
    ]
}, {
    // 流域雨量指数
    name: '流域雨量指数',
    code: 'O019',
    list: [
        { name: '超過なし', src: 'images/basinRainIndex/level_0_up.png' },
        { name: '基準Ⅰ 超過', src: 'images/basinRainIndex/level_1_up.png' },
        { name: '基準Ⅱ 超過', src: 'images/basinRainIndex/level_2_up.png' },
        { name: '基準Ⅲ 超過', src: 'images/basinRainIndex/level_3_up.png' },
        { name: '基準Ⅳ 超過', src: 'images/basinRainIndex/level_4_up.png' },
        { name: '上昇傾向', src: 'images/basinRainIndex/level_2_up.png' },
        { name: '下降傾向', src: 'images/basinRainIndex/level_2_down.png' },
        { name: '昇降なし', src: 'images/basinRainIndex/level_2.png' },
    ]
}, {
    // 地震情報
    name: '地震情報',
    code: 'D004',
    list: [
        { name: '震源', src: '/images/lalert/455.png' },
        { name: '震度', src: '/images/lalert/401.png' }
    ]
}, {
    // 津波警報・注意報
    name: '津波警報・注意報',
    code: 'D006',
    list: [
        { name: '大津波警報', line: '#C800FF' },
        { name: '津波警報', line: '#FF2800' },
        { name: '津波注意報', line: '#FAF500' }
    ]
}, {
    // 火山警報・注意報
    name: '火山警報・注意報（対象市町村の防災対応等）',
    code: 'D104',
    list: [
        { name: '噴火警報：避難等', area: '#6c008c' },
        { name: '噴火警報：入山規制等<br>火口周辺警報：入山規制等', area: '#F89303' },
        { name: '噴火警報：火口周辺警戒<br>火口周辺警報：火口周辺警戒', area: '#faf500' },
        { name: '活火山であることに留意', src: 'images/observation/fff.png' }
    ]
}, {
    // 火山警報・注意報
    name: '火山警報・注意報（火山）',
    code: 'D111',
    list: [
        { name: '【警戒レベル5】避難', src: 'images/observation/volcano_05.png' },
        { name: '【警戒レベル4】避難準備', src: 'images/observation/volcano_04.png' },
        { name: '【警戒レベル3】入山規制', src: 'images/observation/volcano_03.png' },
        { name: '【警戒レベル2】火口周辺規制', src: 'images/observation/volcano_02.png' },
        { name: '【警戒レベル1】活火山であることに留意', src: 'images/observation/volcano_01.png' }
    ]
}, {
    // 降灰予報
    name: '降灰予報',
    code: 'D110',
    list: [
        { name: '小さな噴石の落下', area: 'pink' },
        { name: '多量の降灰', area: 'red' },
        { name: 'やや多量の降灰', area: 'yellow' },
        { name: '少量の降灰', area: 'grey' }
    ]
}, {
    // 台風解析・予報情報
    name: '台風解析・予報情報',
    code: 'O017',
    list: [
        { name: '暴風域', area: '#FF2800' },
        { name: '強風域', area: '#FAF500' },
        { name: '予報円', src: 'images/lalert/tyhoon_line.png' },
        { name: '予想進路', src: 'images/lalert/tyhoon_line_red.png' }
    ]
}, /*{
    // 解析積雪深・解析降雪量
    name: '解析積雪深・解析降雪量',
    code: 'O016',
    list: [
        { name: '～5cm', area: '#A0D2FF' },
        { name: '～20cm', area: '#1C8CFF' },
        { name: '～50cm', area: '#0035FF' },
        { name: '～100cm', area: '#FFF500' },
        { name: '～150cm', area: '#FF9900' },
        { name: '～200cm', area: '#FF2000' },
        { name: '200cm～', area: '#B40068' }
    ]
}, *//* {
    // 土壌雨量指数（実況）
    name: '土壌雨量指数（実況）',
    code: 'O009',
    list: [
        { name: '0-30mm', area: '#DEFFFF' },
        { name: '30mm以上', area: '#9CFFFF' },
        { name: '50mm以上', area: '#0000FF' },
        { name: '70mm以上', area: '#9CFF00' },
        { name: '80mm以上', area: '#319A9C' },
        { name: '90mm以上', area: '#FFFF00' },
        { name: '100mm以上', area: '#FF9A00' },
        { name: '150mm以上', area: '#FF00FF' },
        { name: '200mm以上', area: '#FF0000' },
        { name: '300mm以上', area: '#9C0000' }
    ]
},  */{
    // 土砂災害警戒情報
    name: '土砂災害警戒情報',
    code: 'D105',
    list: [
        { name: '【警戒レベル4相当】発表区域', src: '/images/lalert/dosha_alert.png' }
    ]
}, /* {
    // 土砂災害危険度情報（地区）
    name: '土砂災害危険度情報（地区）',
    code: 'O005',
    list: [
        { name: '【警戒レベル5相当】大雨特別警報（土砂災害）基準超過', area: '#0c000c' },
        { name: '【警戒レベル4相当】実況で基準値超過', area: '#6c008c' },
        { name: '【警戒レベル4相当】1時間後に基準値超過', area: '#c809ff' },
        { name: '【警戒レベル4相当】2時間後に基準値超過', area: '#cc2800' },
        { name: '【警戒レベル4相当】3時間後に基準値超過', area: '#FF7b00' },
        { name: '【警戒レベル3相当】大雨警報（土砂災害）基準超過', area: '#Fae100' },
        { name: '【警戒レベル2相当】大雨注意報基準超過', area: '#9bff9b' }
    ]
},*/ {
    // 土砂災害危険度分布
    name: '土砂災害危険度分布',
    code: 'O016',
    list: [
        { name: '【警戒レベル５相当】<br>災害切迫', area: '#0C000C' },
        { name: '【警戒レベル４相当】<br>危険', area: '#AA00AA' },
        { name: '【警戒レベル３相当】<br>警戒', area: '#FF2800' },
        { name: '【警戒レベル２相当】<br>注意', area: '#F2E700' }
    ]
}, /*{
    // 記録的短時間大雨警報
    name: '記録的短時間大雨警報',
    code: 'D107',
    list: [
        { name: '発表区域', area: 'red' }
    ]
}, {
    // 土壌雨量指数（1時間後の予測）
    name: '土壌雨量指数（1時間後の予測）',
    code: 'O010',
    list: [
        { name: '0-30mm', area: '#DEFFFF' },
        { name: '30mm以上', area: '#9CFFFF' },
        { name: '50mm以上', area: '#0000FF' },
        { name: '70mm以上', area: '#9CFF00' },
        { name: '80mm以上', area: '#319A9C' },
        { name: '90mm以上', area: '#FFFF00' },
        { name: '100mm以上', area: '#FF9A00' },
        { name: '150mm以上', area: '#FF00FF' },
        { name: '200mm以上', area: '#FF0000' },
        { name: '300mm以上', area: '#9C0000' }
    ]
},  */{
    // 災害・被害シミュレーション（SIP4D）
    name: '推定震度情報（震度）',
    code: 'D208',
    list: [
        { name: '震度1', area: '#96B4D3' },
        { name: '震度2', area: '#447ED3' },
        { name: '震度3', area: '#31ADA8' },
        { name: '震度4', area: '#1E973D' },
        { name: '震度5弱', area: '#96D050' },
        { name: '震度5強', area: '#F7F618' },
        { name: '震度6弱', area: '#FAAA46' },
        { name: '震度6強', area: '#F45178' },
        { name: '震度7', area: '#950D05' }
    ]
}, {
    name: '人的被害推定情報（曝露人口数）',
    code: 'D209',
    list: [
        { name: '～1', area: '#F2F2FF' },
        { name: '～5', area: '#00AAFF' },
        { name: '～10', area: '#0041FF' },
        { name: '～25', area: '#FAE696' },
        { name: '～50', area: '#FFE600' },
        { name: '～100', area: '#FF9900' },
        { name: '～500', area: '#FF2800' },
        { name: '～1000', area: '#A50021' },
        { name: '～5000', area: '#B40068' }
    ]
}, {
    name: '建物被害推定情報（被害棟数）',
    code: 'D210',
    list: [
        { name: '～1', area: '#AFF5FF' },
        { name: '～2', area: '#FFFE47' },
        { name: '～5', area: '#FFEB00' },
        { name: '～10', area: '#FF9000' },
        { name: '～20', area: '#FF0000' },
        { name: '～50', area: '#9E0000' },
        { name: '～100', area: '#570000' }
    ]
}, {
    // 防災マップ情報_震度分布予測図
    name: '震度分布予測図',
    code: 'D040',
    list: [
        { name: '震度4', src: '/images/seismic/intensity_4.png' },
        { name: '震度5弱', src: '/images/seismic/intensity_5high.png' },
        { name: '震度5強', src: '/images/seismic/intensity_5low.png' },
        { name: '震度6弱', src: '/images/seismic/intensity_6high.png' },
        { name: '震度6強', src: '/images/seismic/intensity_6low.png' },
        { name: '震度7', src: '/images/seismic/intensity_7.png' }
    ]
}, {
    // 防災マップ情報_液状化予測図
    name: '液状化予測図',
    code: 'D041',
    list: [
        { name: '極めて発生しにくい', src: '/images/seismic/liquefaction_01.png' },
        { name: '発生しにくい', src: '/images/seismic/liquefaction_02.png' },
        { name: '発生しやすい', src: '/images/seismic/liquefaction_03.png' },
        { name: '極めて発生しやすい', src: '/images/seismic/liquefaction_04.png' }
    ]
    // }, {
    //     // 防災マップ情報_浸水想定区域図
    //     name: '浸水想定区域図',
    //     code: 'D020',
    //     list: [
    //         { name: '0.5m未満', src: '/images/flooding/flooding_01.png' },
    //         { name: '0.5～3.0m', src: '/images/flooding/flooding_02.png' },
    //         { name: '3.0～5.0m', src: '/images/flooding/flooding_03.png' },
    //         { name: '5.0～10.0m', src: '/images/flooding/flooding_04.png' },
    //         { name: '家屋倒壊等氾濫想定区域', src: '/images/flooding/flooding_house.png' }
    //     ]
}, {
    name: '浸水想定区域図（寝屋川）',
    code: 'D043',
    list: [
        { name: '0.5m未満', src: '/images/flooding/flooding_neya_01.png' },
        { name: '0.5～1.0m未満', src: '/images/flooding/flooding_neya_02.png' },
        { name: '1.0～2.0m未満', src: '/images/flooding/flooding_neya_03.png' },
        { name: '2.0～3.0m未満', src: '/images/flooding/flooding_neya_04.png' },
        { name: '3.0～4.0m未満', src: '/images/flooding/flooding_neya_05.png' },
        { name: '4.0～5.0m未満', src: '/images/flooding/flooding_neya_06.png' },
        { name: '5.0m以上', src: '/images/flooding/flooding_neya_07.png' }
        // { name: '家屋倒壊等氾濫想定区域', src: '/images/flooding/flooding_neya_house.png' }
    ]
}, {
    name: '浸水想定区域図（東淀川・西淀川）',
    code: 'D044',
    list: [
        { name: '0.5m未満', src: '/images/flooding/flooding_01.png' },
        { name: '0.5～3.0m', src: '/images/flooding/flooding_02.png' },
        { name: '3.0～5.0m', src: '/images/flooding/flooding_03.png' },
        { name: '5.0～10.0m', src: '/images/flooding/flooding_04.png' }
        // { name: '家屋倒壊等氾濫想定区域', src: '/images/flooding/flooding_house.png' }
    ]
}, {
    name: '浸水想定区域図（内水氾濫した場合）',
    code: 'D045',
    list: [
        { name: '0.1～0.3m未満', src: '/images/flooding/inland_flooding_01.png' },
        { name: '0.3～0.5m未満', src: '/images/flooding/inland_flooding_02.png' },
        { name: '0.5～1.0m未満', src: '/images/flooding/inland_flooding_03.png' },
        { name: '1.0～3.0m未満', src: '/images/flooding/inland_flooding_04.png' },
        { name: '3.0～5.0m未満', src: '/images/flooding/inland_flooding_05.png' }
    ]
}, {
    name: '浸水想定区域図（高潮氾濫した場合）',
    code: 'D046',
    list: [
        { name: '0.5m未満', src: '/images/flooding/flooding_01.png' },
        { name: '0.5～3.0m', src: '/images/flooding/flooding_02.png' },
        { name: '3.0～5.0m', src: '/images/flooding/flooding_03.png' },
        { name: '5.0～10.0m', src: '/images/flooding/flooding_04.png' },
        { name: '10.0m以上', src: '/images/flooding/flooding_05.png' }
    ]
}, {
    name: '浸水想定区域図（地震による津波の場合）',
    code: 'D047',
    list: [
        { name: '0.5m未満', src: '/images/flooding/flooding_01.png' },
        { name: '0.5～3.0m', src: '/images/flooding/flooding_02.png' },
        { name: '3.0～5.0m', src: '/images/flooding/flooding_03.png' },
        { name: '5.0～10.0m', src: '/images/flooding/flooding_04.png' }
    ]
}, {
    // 施設情報
    name: '施設情報',
    code: 'M050',
    list: [
        { name: '避難所', src: '/images/facility/facility_evacSh.png' },
        { name: '避難場所', src: '/images/facility/facility_evacLoc.png' },
        { name: '物資拠点', src: '/images/facility/facility_supplyBase.png' },
        { name: '備蓄倉庫', src: '/images/facility/facility_wareHouse.png' },
        { name: '交通', src: '/images/facility/facility_traffic.png' },
        { name: '医療機関', src: '/images/facility/facility_hospital.png' },
        { name: '公共機関', src: '/images/facility/facility_pub.png' },
        { name: '学校', src: '/images/facility/facility_school.png' },
        { name: '高齢者施設', src: '/images/facility/facility_welfare.png' },
        { name: '自衛隊', src: '/images/facility/facility_sdf.png' },
        { name: '警察署', src: '/images/facility/facility_police.png' },
        { name: '消防署', src: '/images/facility/facility_fire.png' }
    ]
}, {
    // 施設情報_防災関連施設
    name: '避難場所等情報',
    code: 'D113',
    list: [
        { name: '広域避難場所', src: '/images/facility/safety_evac_area.png' },
        { name: '避難路', src: '/images/road/evac_road.png' },
        { name: '一時避難場所', src: '/images/facility/124.png' },
        { name: '災害時避難所', src: '/images/facility/125.png' },
        { name: '一時避難場所・災害時避難所', src: '/images/facility/126.png' },
        { name: '津波避難ビル・水害時避難ビル', src: '/images/facility/127.png' }
    ]
}, {
    // 施設情報_防災関連施設_道路情報
    name: '道路情報',
    code: 'D212',
    list: [
        { name: '緊急交通路_広域（重点１４路線）', src: '/images/road/emergency_14_road.png' },
        { name: '緊急交通路_広域（重点１４路線以外）', src: '/images/road/emergency_except14_road.png' },
        { name: '緊急交通路_地域', src: '/images/road/emergency_area_road.png' }
    ]
}, {
    // 施設情報_防災関連施設_その他施設
    name: 'その他施設・標高情報',
    code: 'D022',
    list: [
        { name: '防火水槽・プール（指定水利）', src: '/images/facility/141.png' },
        { name: '災害時用ヘリポート', src: '/images/facility/142.png' },
        { name: '防災スピーカー', src: '/images/facility/143.png' },
        { name: '標高の目安（O.P.=T.P.+1.3m）', src: '/images/facility/151.png' }
    ]
}, {
    // 本部設置状況
    name: '体制状況',
    code: 'D121',
    list: [
        { name: '体制のみ', src: '/images/disasterprevention/fill_noneHq.png' },
        { name: '警戒本部設置', src: '/images/disasterprevention/fill_alertHq.png' },
        { name: '対策本部設置', src: '/images/disasterprevention/fill_responseHq.png' },
        { name: '体制のみ (県)', src: '/images/disasterprevention/noneHq.png' },
        { name: '警戒本部設置 (県)', src: '/images/disasterprevention/alertHq.png' },
        { name: '対策本部設置 (県)', src: '/images/disasterprevention/responseHq.png' }
    ]
}, {
    // 市全体の開設中避難所情報
    name: '避難所開設状況',
    code: 'D_SHELTER',
    list: [
        { name: '開設中(空き)', src: '/images/shelter/open.png' },
        { name: '開設中(やや混雑)', src: '/images/shelter/little_crowded.png' },
        { name: '開設中(混雑)', src: '/images/shelter/crowded.png' },
        { name: '開設中(定員一杯)', src: '/images/shelter/full.png' },
        { name: '開設中(不明)', src: '/images/shelter/unknown.png' },
        { name: '開設準備中', src: '/images/shelter/shelter_pr.png' },
        { name: '閉鎖', src: '/images/shelter/shelter_NotOp.png' },
    ]
}, {
    // 市全体の避難情報
    name: '市全体の避難情報',
    code: 'D_EVAC_ORDER',
    list: [
        { name: '緊急安全確保', area: '#0C000C' },
        { name: '避難指示', area: '#AA00AA' },
        { name: '高齢者等避難', area: '#FF2800' }
    ]
}, {
    // 被害情報
    name: '被害情報',
    code: 'D100',
    list: [
        { name: '住家被害', src: '/images/damage/type_01_urg_1.png' },
        { name: 'ライフライン（電気、水道等）', src: '/images/damage/type_02_urg_1.png' },
        { name: '文教施設（学校等）', src: '/images/damage/type_03_urg_1.png' },
        { name: '病院', src: '/images/damage/type_04_urg_1.png' },
        { name: '庁舎等施設', src: '/images/damage/type_05_urg_1.png' },
        { name: '土砂災害', src: '/images/damage/type_06_urg_1.png' },
        { name: '火災', src: '/images/damage/type_07_urg_1.png' },
        { name: '河川', src: '/images/damage/type_08_urg_1.png' },
        { name: '道路', src: '/images/damage/type_09_urg_1.png' },
        { name: '農地・農業用施設被害', src: '/images/damage/type_10_urg_1.png' },
        { name: '林野被害', src: '/images/damage/type_14_urg_1.png' },
        { name: '港湾・漁港', src: '/images/damage/type_15_urg_1.png' },
        { name: '砂防', src: '/images/damage/type_16_urg_1.png' },
        { name: '公園', src: '/images/damage/type_17_urg_1.png' },
        { name: '空港', src: '/images/damage/type_18_urg_1.png' },
        { name: '海岸', src: '/images/damage/type_19_urg_1.png' },
        { name: 'ダム', src: '/images/damage/type_20_urg_1.png' },
        { name: '下水', src: '/images/damage/type_21_urg_1.png' },
        { name: '県営住宅', src: '/images/damage/type_22_urg_1.png' },
        { name: '鉄道', src: '/images/damage/type_23_urg_1.png' },
        { name: 'その他被害', src: '/images/damage/type_11_urg_1.png' },
        { name: '簡易報告', src: '/images/damage/type_12_urg_1.png' },
        { name: '現地画像', src: '/images/damage/type_13_urg_1.png' },
        { name: '緊急度(高)', area: '#FF0000' },
        { name: '緊急度(中)', area: '#FFE699' },
        { name: '緊急度(低)', src: 'images/damage/urgency_0.png' },
        { name: '確認中', src: 'images/damage/status_01_legend.png' },
        { name: '対応待ち・対応中', src: 'images/damage/status_02_legend.png' },
        { name: '対応済', src: 'images/damage/status_03_legend.png' },
        { name: '人的被害あり', src: 'images/damage/hmSuff_0.png' },
        { name: '人的被害なし', src: 'images/damage/hmSuff_1.png' }
    ]
}, {
    // 部隊活動情報
    name: '部隊活動情報',
    code: 'D120',
    list: [
        { name: '自衛隊', src: '/images/rescue/closed_1.png' },
        { name: '警察', src: '/images/rescue/closed_2.png' },
        { name: '消防', src: '/images/rescue/closed_3.png' },
        { name: 'その他', src: '/images/rescue/closed_9.png' },
        { name: '活動予定', src: '/images/rescue/future_legend.png' },
        { name: '活動中', src: '/images/rescue/going_legend.png' },
        { name: '活動完了', src: '/images/rescue/closed_legend.png' }
    ]
}, /* {
    // 現在の規制情報
    name: '規制情報',
    code: 'R001',
    list: [
        { name: '通行止め・閉鎖', src: '/images/road/blocked.gif' },
        { name: '大型車通行止め', src: '/images/road/big_blocked.gif' },
        { name: '片側交互通行', src: '/images/road/one_side.gif' },
        { name: '車線規制', src: '/images/road/narrows.gif' },
        { name: '災害・事故規制', src: '/images/road/saigai.gif' },
        { name: '事前通行規制', src: '/images/road/blocked_before.gif' },
        { name: '歩行者・二輪車通行止め', src: '/images/road/walker_bike.gif' }
    ]
}, {
    // 事前通行規制情報
    name: '事前通行規制区間情報',
    code: 'R002',
    list: [
        { name: '雨による規制区間', src: '/images/road/rain.gif' },
        { name: '風による規制区間', src: '/images/road/wind.gif' },
        { name: '越波による規制区間', src: '/images/road/nami.gif' },
        { name: '冠水による規制区間', src: '/images/road/kansui.gif' },
        { name: '冬季閉鎖通行規制区間', src: '/images/road/snow.gif' }
    ]
}, {
    // 事前通行規制情報
    name: '道路カメラ・冬季通行規制情報',
    code: 'R003',
    list: [
        { name: 'カメラ', src: '/images/road/camera.gif' },
        { name: '路面状況', src: '/images/road/slip.gif' }
    ]
}, {
    // 事前通行規制情報
    name: '走行注意区間',
    code: 'R004',
    list: [
        { name: '落石やがけ崩れの発生するおそれが高い区間', src: '/images/road/rakuseki_04.gif' },
        { name: '落石やがけ崩れの発生するおそれがやや高い区間', src: '/images/road/rakuseki_03.gif' }
    ]
}, {
    // 事前通行規制情報
    name: '緊急輸送道路',
    code: 'R005',
    list: [
        { name: '第一次緊急輸送道路（高規格幹線道路）', src: '/images/road/route_01.gif' },
        { name: '第一次緊急輸送道路（その他）', src: '/images/road/route_02.gif' },
        { name: '第二次緊急輸送道路', src: '/images/road/route_03.gif' },
        { name: '第三次緊急輸送道路', src: '/images/road/route_04.gif' }
    ]
}, {
    // 今後の規制情報
    name: '今後の規制情報',
    code: 'R006',
    list: [
        { name: '通行止め・閉鎖', src: '/images/road/blocked.gif' },
        { name: '大型車通行止め', src: '/images/road/big_blocked.gif' },
        { name: '片側交互通行', src: '/images/road/one_side.gif' },
        { name: '車線規制', src: '/images/road/narrows.gif' },
        { name: '災害・事故規制', src: '/images/road/saigai.gif' },
        { name: '事前通行規制', src: '/images/road/blocked_before.gif' },
        { name: '歩行者・二輪車通行止め', src: '/images/road/walker_bike.gif' }
    ]
}, */ {
    // 災害情報共有システム報告
    name: '災害情報報告',
    code: 'D116',
    list: [
        { name: '管理者からの報告', src: '/images/draw/icon/078.png' },
        { name: '支援団体からの報告', src: '/images/draw/icon/076.png' },
        { name: '支援者からの報告', src: '/images/draw/icon/077.png' }
    ]

}, {
    // Specteeお気に入り情報
    name: 'SNSサービス登録情報',
    code: 'D117',
    list: [
        { name: '鉄道情報', src: '/images/spectee/event_railway.png' },
        { name: '気象', src: '/images/spectee/event_weather.png' },
        { name: '火災', src: '/images/spectee/event_fire.png' },
        { name: '事故・道路情報', src: '/images/spectee/event_accident.png' },
        { name: '事件', src: '/images/spectee/event_incident.png' },
        { name: 'ライフライン', src: '/images/spectee/event_lifeline.png' },
        { name: 'その他', src: '/images/spectee/event_other.png' }
    ]
},

/**
 * 以下、SIP4D連携情報
 */
{
    // 強振動指標
    name: '強振動指標',
    code: 'S005',
    list: [
        { name: '震度１', area: '#95b4d3' },
        { name: '震度２', area: '#447eb8' },
        { name: '震度３', area: '#32aca8' },
        { name: '震度４', area: '#1c973d' },
        { name: '震度５弱', area: '#96d050' },
        { name: '震度５強', area: '#f8f618' },
        { name: '震度６弱', area: '#faaa47' },
        { name: '震度６強', area: '#f45278' },
        { name: '震度７', area: '#950d06' }
    ]
}, {
    // 建物被害推定(全壊棟数)
    name: '建物被害推定(全壊棟数)',
    code: 'S006',
    list: [
        { name: '100棟以上', area: '#570000' },
        { name: '100棟未満', area: '#9E0000' },
        { name: '50棟未満', area: '#FF0000' },
        { name: '20棟未満', area: '#FF9000' },
        { name: '10棟未満', area: '#FFEB00' },
        { name: '5棟未満', area: '#FFFE47' },
        { name: '1棟以上 2棟未満', area: '#AFF5FF' }
    ]
}, {
    // 建物被害推定(全半壊棟数)
    name: '建物被害推定(全半壊棟数)',
    code: 'S007',
    list: [
        { name: '100棟以上', area: '#570000' },
        { name: '100棟未満', area: '#9E0000' },
        { name: '50棟未満', area: '#FF0000' },
        { name: '20棟未満', area: '#FF9000' },
        { name: '10棟未満', area: '#FFEB00' },
        { name: '5棟未満', area: '#FFFE47' },
        { name: '1棟以上 2棟未満', area: '#AFF5FF' }
    ]
}, {
    // 道路状況
    name: '道路情報（地方整備局）',
    code: 'S003',
    list: [
        { name: '通行止', src: '/images/draw/icon/092.png' },
        { name: '規制', src: '/images/draw/icon/1023.png' },
        { name: 'その他', src: '/images/draw/icon/050.png' }
    ]
}, {
    // 道路状況
    name: '道路情報（自治体提供）',
    code: 'S004',
    list: [
        { name: '全面通行止', src: 'images/traffic/fukushima/all_stop.gif' },
        { name: '全面通行止<br>(異常気象等)', src: 'images/traffic/fukushima/all_stop_saigai.gif' },
        { name: '大型車通行止', src: 'images/traffic/fukushima/large_stop.gif' },
        { name: '全面通行止<br>(時間規制)', src: 'images/traffic/fukushima/all_stop_time.gif' },
        { name: '全面通行止<br>(時間規制)(異常気象等)', src: 'images/traffic/fukushima/all_stop_saigai_time.gif' },
        { name: '大型車通行止<br>(時間規制)', src: 'images/traffic/fukushima/large_stop_time.gif' },
        { name: '冬期通行止', src: 'images/traffic/fukushima/winter_stop.gif' },
        { name: '冬期通行止<br>(時間規制)', src: 'images/traffic/fukushima/winter_stop_time.gif' }
    ]
}, {
    // 医療機関情報
    name: '医療機関情報',
    code: 'S013',
    list: [
        { name: '病院', src: '/images/draw/icon/035.png' },
        { name: '災害拠点指定あり（支援要）', src: '/images/draw/icon/076.png' }
    ]
}, {
    // 医療機関情報
    name: '医療機関情報',
    code: 'S014',
    list: [
        { name: '病院', src: '/images/draw/icon/035.png' },
        { name: '災害拠点指定あり（支援要否未定）', src: '/images/draw/icon/077.png' }
    ]
}, {
    // 医療機関情報
    name: '医療機関情報',
    code: 'S015',
    list: [
        { name: '病院', src: '/images/draw/icon/035.png' },
        { name: '災害拠点指定なし（支援要）', src: '/images/draw/icon/1112.png' }
    ]
}, {
    // 医療機関情報
    name: '医療機関情報',
    code: 'S016',
    list: [
        { name: '病院', src: '/images/draw/icon/035.png' },
        { name: '災害拠点指定なし（支援要否未定）', src: '/images/draw/icon/1113.png' }
    ]
}, {
    // 物資拠点
    name: '物資拠点',
    code: 'S012',
    list: [
        { name: '物資拠点', src: '/images/draw/icon/1116.png' }
    ]
}, {
    // SIP4D避難所
    name: '避難所',
    code: 'S017',
    list: [
        { name: '開設・常設', src: 'images/draw/icon/shelter_op.png' },
        { name: '定員超過', src: 'images/draw/icon/shelter_ex.png' },
        { name: '閉鎖', src: 'images/draw/icon/shelter_not_ac.png' },
        { name: '未開設・不明', src: 'images/draw/icon/shelter_pre.png' }
    ]
}, {
    // クロノロジ情報
    name: 'クロノロジ情報',
    code: 'D160',
    list: [
        { name: '組織内情報', src: '/images/chronology/org_01.png' },
        // { name: '情報提供', src: '/images/chronology/info_01.png' },
        { name: '要請：救出・救助', src: '/images/chronology/rescue_01.png' },
        { name: '要請：応援・受援', src: '/images/chronology/support_01.png' },
        { name: '要請：交通', src: '/images/chronology/traffic_01.png' },
        { name: '要請：医療', src: '/images/chronology/medical_01.png' },
        { name: '要請：ライフライン', src: '/images/chronology/life_01.png' },
        { name: '要請：生活情報', src: '/images/chronology/living_01.png' },
        { name: '要請：警察', src: '/images/chronology/police_01.png' },
        { name: '要請：自衛隊', src: '/images/chronology/sdf_01.png' },
        { name: '要請：消防', src: '/images/chronology/fire_01.png' },
        { name: '要請：ヘリ要請', src: '/images/chronology/helicopter_01.png' },
        { name: '要請：国', src: '/images/chronology/country_01.png' },
        { name: '要請：その他', src: '/images/chronology/other_01.png' },
        { name: '----' },
        { name: '緊急度：低', src: '/images/chronology/org_01.png' },
        { name: '緊急度：中', src: '/images/chronology/org_02.png' },
        { name: '緊急度：高', src: '/images/chronology/org_03.png' },
        { name: '----' },
        { name: '対応状況：未対応', src: '/images/damage/status_01_legend.png' },
        { name: '対応状況：対応中', src: '/images/damage/status_02_legend.png' },
        { name: '対応状況：対応済', src: '/images/damage/status_03_legend.png' },
    ]
}, {
    // 停電情報
    name: '停電情報',
    code: 'L001',
    list: [
        { name: '停電なし', area: '#caffff' },
        { name: '～1,000戸', area: '#f5ff00' },
        { name: '1,001戸～10,000戸', area: '#fcc400' },
        { name: '10,001戸～', area: '#ff0000' }
    ]
}, {
    // 道路カメラ
    name: '道路カメラ',
    code: 'L002',
    list: [
        { name: 'カメラ', src: 'images/facility/traffic_camera.png' }
    ]
}]);
